import React from 'react';
import { GiftIcon } from 'lucide-react';
import { BONUSES_VALUE } from '../data/offer';
const bonuses = [{
  number: '01',
  title: 'Kit Documenti del Coach Professionista',
  price: '€15',
  body: 'In una professione senza albo, i documenti sono il primo segnale verificabile che il cliente riceve, e arrivano prima di qualunque seduta. Questo kit raccoglie i modelli che nessun corso di coaching fornisce: accordo di percorso articolo per articolo, informativa privacy, politica di cancellazione, attestato e fattura.',
  note: 'Non costituisce consulenza legale: è consigliata una revisione da parte di un professionista.',
  image: 'https://cdn.magicpatterns.com/uploads/q72rH13xkZZ9MfgsQGKerF/bonus-1.png'
}, {
  number: '02',
  title: 'Il Quaderno del Percorso',
  price: '€9',
  body: 'Un quaderno di lavoro stampabile, personalizzabile con il tuo logo, che consegni al cliente nella prima seduta. Contiene la sua destinazione, la mappa delle tre fasi, una pagina per ogni seduta, il Registro delle Ancore e il protocollo personale da usare tra un incontro e l’altro.',
  image: 'https://cdn.magicpatterns.com/uploads/4fC7ujtnMLiY4tALPGfETE/bonus-2.png'
}, {
  number: '03',
  title: 'La Sessione Conoscitiva Completa',
  price: '€8',
  body: 'Il colloquio preliminare è il punto in cui la maggior parte dei coach perde le persone che avrebbe potuto aiutare. Questa guida contiene la traccia completa dei trenta minuti, con gli script di apertura, diagnosi condivisa e proposta, e le obiezioni più frequenti con la risposta.',
  image: 'https://cdn.magicpatterns.com/uploads/eZTsHQHqhZXkxd84M2z2tx/bonus-3.png'
}, {
  number: '04',
  title: 'Il Cruscotto della Pratica',
  price: '€19',
  body: 'Quasi tutti i coach decidono in base alla sensazione dell’ultimo mese. Questo cruscotto contiene i sei indicatori che raccontano davvero come sta andando la tua attività: sessioni conoscitive, percorsi avviati, percorsi completati, referenze. Si compila in dieci minuti al mese.',
  image: 'https://cdn.magicpatterns.com/uploads/vPYc3L4L6rRbPizbRs3eWb/bonus-4.png'
}, {
  number: '05',
  title: 'Avvio Rapido',
  price: '€13',
  body: 'Sei tomi sono un sistema completo. Sono anche un ottimo motivo per rimandare. Questa guida porta al primo percorso condotto con il metodo in quattordici giorni, leggendo il minimo indispensabile: cosa leggere ogni giorno, cosa stampare, cosa portare in seduta.',
  image: 'https://cdn.magicpatterns.com/uploads/eFhTGzaNp4pY6CDGHDHhiP/bonus-5.png'
}];
export function Bonuses() {
  return <section aria-labelledby="bonuses-heading" className="w-full bg-white" data-id="element-26" data-mp="32rjw7p7x6d8w">
      <div className="max-w-6xl mx-auto px-5 sm:px-8 py-14 sm:py-20" data-id="element-27" data-mp="37kv6y1fure63">
        <div className="text-center" data-id="element-28" data-mp="2a4pkbgp64m71">
          <span className="inline-flex items-center gap-2 rounded-full bg-terracotta-soft text-terracotta px-4 py-2 text-xs font-bold uppercase tracking-[0.12em]" data-id="element-29" data-mp="2a3o28s9qizft">
            <GiftIcon className="w-4 h-4" aria-hidden="true" data-id="element-30" data-mp="27kjcgxxfobl7" />
            5 bonus professionali inclusi
          </span>
          <h2 id="bonuses-heading" className="mt-5 font-serif font-bold text-ink text-2xl sm:text-4xl leading-snug max-w-3xl mx-auto" data-id="element-31" data-mp="22lydf1tx3xyc">
            Valore totale:{' '}
            <span className="line-through text-ink-muted" data-id="element-32" data-mp="1tjgp8hupcv8p">{BONUSES_VALUE}</span>{' '}
            <span className="text-vital" data-id="element-33" data-mp="1olf4lshmonv4">→ inclusi</span> con Il Sistema
            Completo del Coach
          </h2>
        </div>

        <ul className="mt-10 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5" data-id="element-34" data-mp="1jsucqwia8ku8">
          {bonuses.map(bonus => <li key={bonus.number} className="flex flex-col rounded-2xl bg-cream border border-cream-dark shadow-card overflow-hidden" data-id="element-35" data-mp="1eszo6zlzc7cc">
              <div className="bg-cream border-b border-cream-dark" data-id="element-36" data-mp="15turlytzao2t">
                <img src={bonus.image} alt={`${bonus.title} — copertina del bonus`} className="w-full h-56 sm:h-64 object-contain mix-blend-multiply" loading="lazy" data-id="element-37" data-mp="10wm7hsp9s9yx" />
              </div>
              <div className="flex items-center justify-between gap-3 p-6 pb-0" data-id="element-38" data-mp="2r8965ybiu84z">
                <span className="font-serif font-bold text-sm text-terracotta tracking-[0.14em] uppercase" data-id="element-39" data-mp="2r66hbhm3ul1u">
                  Bonus {bonus.number}
                </span>
                <span className="flex items-center gap-2" data-id="element-40" data-mp="2h8ictzyp5z6h">
                  <span className="text-sm text-ink-muted line-through" data-id="element-41" data-mp="2m96ergogs0fh">
                    {bonus.price}
                  </span>
                  <span className="rounded-full bg-vital text-white text-[10px] font-bold uppercase tracking-wider px-2.5 py-1" data-id="element-42" data-mp="28apxwwww0tjm">
                    Incluso
                  </span>
                </span>
              </div>
              <h3 className="mt-3 px-6 font-serif font-bold text-lg sm:text-xl text-ink leading-snug" data-id="element-43" data-mp="6fpdicmb7zru">
                {bonus.title}
              </h3>
              <div className="mt-3 px-6 pb-6 flex-grow" data-id="element-44" data-mp="llv22ezjhigk">
                <p className="text-[15px] leading-relaxed text-ink-soft" data-id="element-45" data-mp="glp64mm8l9so">
                  {bonus.body}
                </p>
                {bonus.note && <p className="mt-3 text-xs leading-relaxed text-ink-muted italic" data-id="element-46" data-mp="ueok2k6devy4">
                    {bonus.note}
                  </p>}
              </div>
            </li>)}
        </ul>
      </div>
    </section>;
}